import { useTranslation } from 'react-i18next'

import type { UpdateFavoriteListModalProps } from './type'

import { Dialog } from '@/components/ui'

import { UpdateFavoriteListForm } from './Form'

export const UpdateFavoriteListSalesTypeModal = ({
  isOpen,
  favorite,
  onClickConfirm,
  onClickCancel,
}: UpdateFavoriteListModalProps) => {
  const { t } = useTranslation()

  return (
    <Dialog title={t('favorite.item.settings')} isOpen={isOpen}>
      <UpdateFavoriteListForm
        favorite={favorite}
        onClickConfirm={onClickConfirm}
        onClickCancel={onClickCancel}
      />
    </Dialog>
  )
}
